$.widget('cwi.imagemagnify', {
	options : {
		magWidth:'auto', /* int value or keyword: auto, half, quarter */
		magHeight:'auto', /* int value or keyword: auto, half, quarter */
		contain:false, /* whether the zoomed area should be contained to the image coordinates */
		zoom:2
	},
	
	_create: function() {
		var self = this;
		this.element.mousemove(function(ev) { self._handleMouseMove(ev, {x:ev.pageX, y:ev.pageY}); });
		this.element.mouseout(function(ev) { self._handleMouseOut(ev); });
		this.element.on('touchstart touchmove', function(ev) { 
			var touchTargetEvent = ev.originalEvent.targetTouches[0];
			self._handleMouseMove(ev, {x:touchTargetEvent.pageX, y:touchTargetEvent.pageY});
			ev.preventDefault();
		});
		this.element.on('touchend touchcancel', function(ev) { self._handleMouseOut(ev); });

		this.magBoxElement = $('<div class="imagemagnify" />').css({pointerEvents:'none',display:'none',position:'absolute',overflow:'hidden'}).appendTo($('body'));
		this.magImgElement = this.element.clone().css({position:'absolute',left:0,top:0,margin:0}).appendTo(this.magBoxElement);
		// Updated in _init
		this.magWidth = null;
		this.magWidth = null;
		this.imageWidth = null;
		this.imageHeight = null;
	},
	_imageSizeCalculations : function() {
		
		this.imageWidth = this.element.width();
		this.imageHeight = this.element.height();
		
		/**
		 * Positioning
		 */
		var optMagWidth = this.options.magWidth;
		var optMagHeight = this.options.magHeight;
		
		if (optMagWidth == 'auto') this.magWidth = this.imageWidth;
		else if (optMagWidth == 'half') this.magWidth = Math.floor(this.imageWidth/2);
		else if (optMagWidth == 'quarter') this.magWidth = Math.floor(this.imageWidth/4);
		else this.magWidth = optMagWidth;
				
		if (optMagHeight == 'auto') this.magHeight = this.imageHeight;
		else if (optMagHeight == 'half') this.magHeight = Math.floor(this.imageHeight/2);
		else if (optMagHeight == 'quarter') this.magHeight = Math.floor(this.imageHeight/2);
		else this.magHeight = optMagHeight;
		
		// Square zoom area if settings are set for auto
		if (optMagWidth == 'auto' && parseInt(this.magHeight) > 0 && this.magWidth > this.magHeight) this.magWidth = this.magHeight;
		if (optMagHeight == 'auto' && parseInt(this.magWidth) > 0 && this.magHeight > this.magWidth) this.magHeight = this.magWidth;
		
		if (this.magWidth == 0) this.magWidth = 100;
		if (this.magHeight == 0) this.magHeight = 100;
		/**
		 * Elements
		 */
		 this.magBoxElement.css({
			width:this.magWidth,
			height:this.magHeight
		});
		
		this.magImgElement.css({
			width:this.imageWidth * this.options.zoom,
			height:this.imageHeight * this.options.zoom
		});
	},
	_handleMouseMove : function(ev, targetCoords) {

		this._imageSizeCalculations();

		var l = this.element.offset().left, t = this.element.offset().top;
		
		var mx = targetCoords.x - l; // mouse x
		var my = targetCoords.y - t; // mouse y
		
		var bx = Math.floor(targetCoords.x-(this.magWidth/2)), by = Math.floor(targetCoords.y-(this.magHeight/2));
		var offsetX = 0, offsetY = 0;
		
		// Check whether zoom popup should be contained with the original image coordinates
		if (this.options.contain) {
			if (bx < l) offsetX = l - bx;
			else if ( (mx+this.magWidth/2) > this.imageWidth) {
				offsetX = -((mx+this.magWidth/2) - this.imageWidth);
			}
			if (by < t) offsetY = t - by;
			else if ( (my+this.magHeight/2) > this.imageHeight) {
				offsetY = -((my+this.magHeight/2) - this.imageHeight);
			}
			
			bx += offsetX;
			by += offsetY;
		}
		
		this.magBoxElement.css({left:bx,top:by});
		
		this.magImgElement.css({
			marginLeft:(-mx*this.options.zoom) + Math.ceil(this.magWidth/2)-1 - offsetX,
			marginTop:(-my*this.options.zoom) + Math.ceil(this.magHeight/2)-1 - offsetY
		});
		this.magBoxElement.show();
	},
	_handleMouseOut : function(ev) {
		this.magBoxElement.hide();
	}
});